import templateStr from 'text!./AdditionalCoverages.html';

export default {
    restrict: 'E',
    bindings: {
        lobCode: '&',
        coverageData: '<',
        schedules: '<'
    },
    template: templateStr,
    controller: function controller() {}
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/quoteandbind/directives/LobOfferingSelection/AdditionalCoverages/AdditionalCoverages.js
// module id = 1218
// module chunks = 0